import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IScheduleApiResponse } from '~/utils/interface/schedule';
import { CalendarViewMode, ScheduleMode } from '~/utils/types/schedule';
import { handleGetEvents } from './scheduleThunk';
import dayjs from 'dayjs';
import { DEFAULT_VIEW_MODE, SCHEDULE_MODE_FULL } from '~/utils/constants/schedules';

export interface ScheduleState {
  events: Array<IScheduleApiResponse>;
  scheduleMode: ScheduleMode;
  calendarViewMode: CalendarViewMode;
  selectedEventId: string | undefined;
  openAlertDelete: boolean;
  needRefreshData: boolean;
  currentTime: string;
}

const initialState: ScheduleState = {
  events: [],
  scheduleMode: SCHEDULE_MODE_FULL,
  calendarViewMode: DEFAULT_VIEW_MODE,
  currentTime: dayjs().format('YYYY-MM-DD'),
  selectedEventId: undefined,
  openAlertDelete: false,
  needRefreshData: false,
};

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    goToday(state) {
      state.currentTime = dayjs().format('YYYY-MM-DD');
    },
    goPreviousTime(state) {
      const previousTime = dayjs(state.currentTime).subtract(1, state.calendarViewMode);
      state.currentTime = previousTime.format('YYYY-MM-DD');
    },
    goNextTime(state) {
      const nextTime = dayjs(state.currentTime).add(1, state.calendarViewMode);
      state.currentTime = nextTime.format('YYYY-MM-DD');
    },
    changeScheduleMode(state, action: PayloadAction<ScheduleMode>) {
      state.scheduleMode = action.payload;
    },
    changeCalendarViewMode(state, action: PayloadAction<CalendarViewMode>) {
      state.currentTime = dayjs().format('YYYY-MM-DD');
      state.calendarViewMode = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeSelectedEventId(state, action: PayloadAction<string>) {
      state.selectedEventId = action.payload;
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetEvents.pending, (state, action) => {})
      .addCase(handleGetEvents.fulfilled, (state, action) => {
        state.events = action.payload.responses;
        state.needRefreshData = false;
      })
      .addCase(handleGetEvents.rejected, (state, action) => {});
  },
});

export const scheduleActions = scheduleSlice.actions;

const scheduleReducer = scheduleSlice.reducer;
export default scheduleReducer;
